import { useOrganization } from '@utils/api/users/use-get-organization';
import { SupportedCurrency } from '@utils/types/organization/organization';

export function useOrgCurrency(): SupportedCurrency {
  const { data } = useOrganization();
  return data?.invoice_currency ?? 'EUR';
}
